import BaseClient from './baseClient';

class RankingClient extends BaseClient {
  async getRules(params: { ruleId?: string; ruleName?: string }): Promise<{
    data: RankingRule[];
    pages: {
      next: string;
      prev?: string;
    };
  }> {
    const queryParams = new URLSearchParams();
    Object.entries(params)
      .filter(([_, value]) => value !== undefined)
      .forEach(([key, value]) => {
        queryParams.append(key, String(value));
      });
    return this.fetch('/ranking-rule/v1/list?' + queryParams);
  }
  next(nextPage: string): Promise<{
    data: RankingRule[];
    pages: {
      next: string;
      prev?: string;
    };
  }> {
    return this.fetch(nextPage);
  }

  createRankingRule(payload: RankingRule) {
    return this.fetch(`/ranking-rule/v1/`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }

  updateRankingRule(id: string, payload: RankingRule) {
    return this.fetch(`/ranking-rule/v1/id/${id}`, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
  }

  toggleRankingRuleStatus(id: string, currentStatus: string) {
    const payload = {
      status: currentStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE',
    };
    return this.fetch(`/ranking-rule/v1/id/${id}/status`, {
      method: 'PATCH',
      body: JSON.stringify(payload),
    });
  }
}

export default new RankingClient();
